import React from 'react'
import '../css/SkillsCards.css'

const SkillsCards = ({ mySkills, isProjects }) => {
    return (

        mySkills.map((eachSkill) => {

            return (
                <div className={isProjects === false ? "skillsCardContainer" : "projectsCardContainer"} key={eachSkill.id}>
                    <div>
                        <div className="skillsCardTitle">
                            <div>
                                <div className="programmingLanguageName">
                                {eachSkill.name}
                                </div>
                                { isProjects !== false ? <div className="programmingLanguageLogo mb-3 font-weight-bold">Created At : {eachSkill.created_at}</div> : "" } 
                            </div>
                            { isProjects === false ? "" : <div className="programmingLanguageLogo">{eachSkill.language}</div> }
                        </div>
                        <div className="skillsCardDescription">{eachSkill.description}</div> 
                    </div>
                    { isProjects === false ? "" : <div className="git"><a href={eachSkill.svn_url} rel="noreferrer" target="_blank" className="githubBtn">Github</a></div>}           
                </div>
            )

        })
    )
    
}

export default SkillsCards
